import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";


class HomeSections extends React.Component<any, any> {

        componentDidMount() {
            window.scrollTo(0, 0);
        }

        componentDidUpdate(prevProps) {
            if (prevProps.isLoading && !this.props.isLoading) {
                window.scrollTo(0, 0);
            }
        }

        render() {
            let sectionOneContent;

            let sectionOneLink;
            let sectionTwoLink;

            if (this.props.homeSettings && !this.props.isLoading) {
                sectionOneContent = (<div className="container sectionOneContent">
                    <text className="mb-2">{this.props.homeSettings.sectionOneText.split('<br />').map((text, index) => {
                        return index == 0 ? <span>{text}</span> : <span><br />{text}</span>
                    })}</text>
                    <div className="home-section-buttons d-flex align-items-center justify-content-center" style={{gap: '20px',}}>
                        <a className="emphasis-link btn btn-pill-teal" href={this.props.homeSettings.sectionOneLink}>
                            {this.props.homeSettings.sectionOneLinkText}
                        </a>
                        <a className="emphasis-link btn btn-pill-peach" href={this.props.homeSettings.sectionTwoLink}>
                            {this.props.homeSettings.sectionTwoLinkText}
                        </a>
                    </div>
                </div>);
        }


            return (
                <div className="home-sections-wrapper">
                    <div className="circle-container">
                        <div className="d-flex flex-column align-items-center">
                            <div className="home-sections-offset">{sectionOneContent}</div>
                        </div>
                    </div>
                </div>
            );
        }
    }
const mapStateToProps = (state, ownProps) => {
    return {
        homeSettings: state.siteData.siteData.homeSettings,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const HomeSectionsContainer = connect(mapStateToProps, mapDispatchToProps)(
    HomeSections
);

export default HomeSectionsContainer;


// WEBPACK FOOTER //
// ./src/components/Home/HomeSections.tsx